import { action } from "../common/Action"
import { BolliniVerdiClient, BollinoDataDto, BollinoDto } from "../generated";

const service = new BolliniVerdiClient();

class BolliniVerdiActions {

    @action
    public async getByImpianto(idImpianto: number) {
        const bolliniVerdi = await service.getByImpianto(idImpianto);
        return { idImpianto, bolliniVerdi };
    }

    @action
    public async add(bollino: BollinoDataDto) {
        const id = await service.add(bollino);
        if (id > 0) {
            return { ...bollino, idBollino: id } as BollinoDto;
        }

        return null;
    }

    @action
    public async update(idBollino, bollino: BollinoDataDto) {
        if (await service.update(bollino, idBollino))
            return { ...bollino, idBollino } as BollinoDto;
        return null;
    }

    @action
    public async delete(idImpinato: number, idBollino: number) {
        let resultOk = await service.delete(idBollino);
        if (resultOk)
            return { idImpinato, idBollino };
        else return null;
    }
}
export default new BolliniVerdiActions();